import { render, staticRenderFns } from "./SpouseHomeData.vue?vue&type=template&id=7c5ae04a&"
import script from "./SpouseHomeData.vue?vue&type=script&lang=js&"
export * from "./SpouseHomeData.vue?vue&type=script&lang=js&"
import style0 from "./SpouseHomeData.vue?vue&type=style&index=0&id=7c5ae04a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports